export const PRICING = [
  {
    id: "bronce",
    name: "Bronce",
    price: 99,
    description: "Diagnóstico forense + informe detallado",
    highlight: false,
    features: [
      "Diagnóstico inicial en 12h",
      "Informe de vulnerabilidades",
      "Plan de acción recomendado",
      "Estimación de tiempos y costos"
    ]
  },
  {
    id: "plata",
    name: "Plata",
    price: 249,
    description: "Recuperación + blindaje básico",
    highlight: false,
    features: [
      "Recuperación de sitio",
      "Limpieza de malware",
      "Actualizaciones críticas",
      "Hardening básico (firewall, login)"
    ]
  },
  {
    id: "oro",
    name: "Oro",
    price: 399,
    description: "Recuperación 24h + certificado y monitoreo 1 mes",
    highlight: true,
    features: [
      "Recuperación express < 24h",
      "Certificado de seguridad",
      "Monitoreo 24/7 por 30 días",
      "Lista negra: verificación y remoción"
    ]
  }
];

export const SERVICES = [
  {
    id: "optimizacion",
    icon: "Gauge",
    title: "OPTIMIZACIÓN",
    desc: "Velocidad y rendimiento técnico de tu sitio web",
    features: [
      "Análisis de PageSpeed y Core Web Vitals",
      "Optimización de imágenes y caché",
      "Minificación de CSS/JS",
      "CDN y compresión GZIP/Brotli"
    ]
  },
  {
    id: "rescate",
    icon: "AlertTriangle",
    title: "RESCATE",
    desc: "Recuperación de emergencias en 24h garantizada",
    features: [
      "Diagnóstico forense inmediato",
      "Limpieza de malware y restauración",
      "Recuperación de backups",
      "Atención 24/7 en crisis"
    ]
  },
  {
    id: "seguridad",
    icon: "ShieldAlert",
    title: "SEGURIDAD",
    desc: "Protección y hardening profesional",
    features: [
      "Firewall y WAF configurado",
      "Actualización de vulnerabilidades",
      "Auditoría de plugins/temas",
      "Certificados SSL y HTTPS"
    ]
  },
  {
    id: "blindaje",
    icon: "Lock",
    title: "BLINDAJE",
    desc: "Mantenimiento proactivo y prevención",
    features: [
      "Monitoreo 24/7",
      "Backups automáticos diarios",
      "Actualizaciones programadas",
      "Reportes mensuales de seguridad"
    ]
  }
];

export const PROBLEMS = [
  { icon: "AlertTriangle", title: "Pantalla roja (malware)", desc: "Avisos de seguridad o bloqueo del navegador." },
  { icon: "Server", title: "Sitio caído 500/404", desc: "Errores del servidor o páginas no encontradas." },
  { icon: "Gauge", title: "Rendimiento lento", desc: "Carga lenta, alto TTFB, timeout en hosting." },
  { icon: "ShieldAlert", title: "Ransomware / inyección", desc: "Mensajes de rescate, enlaces spam, redirecciones." }
];

export const PROCESS = [
  { step: 1, title: "Diagnóstico Forense", desc: "Análisis completo del vector de ataque, archivos comprometidos y alcance del daño." },
  { step: 2, title: "Limpieza y Recuperación", desc: "Eliminación de malware, restauración de archivos limpios y recuperación de funcionalidad." },
  { step: 3, title: "Blindaje", desc: "Endurecimiento de seguridad: firewall, permisos, credenciales y actualizaciones críticas." },
  { step: 4, title: "Entrega y Prevención", desc: "Documentación completa, checklist de seguridad y recomendaciones para prevenir futuros ataques." }
];

export const STATS = [
  { label: "+200 sitios", value: "recuperados" },
  { label: "24/7", value: "soporte" },
  { label: "9h", value: "tiempo medio" },
  { label: "98%", value: "satisfacción" }
];

export const TESTIMONIALS = [
  {
    name: "Ana Gómez",
    role: "Ecommerce Owner",
    quote: "Pensé que lo perdía todo. En menos de 12 horas mi tienda volvió a operar.",
    initials: "AG"
  },
  {
    name: "Carlos Ruiz",
    role: "Agencia Creativa",
    quote: "Limpieza impecable y blindaje real. Bajó el spam y mejoró el PageSpeed.",
    initials: "CR"
  },
  {
    name: "Lucía Pérez",
    role: "Bloguera",
    quote: "Me guiaron en todo. Claridad, rapidez y cero tecnicismos innecesarios.",
    initials: "LP"
  }
];

export const FAQS = [
  {
    q: "¿Pueden recuperarlo en menos de 24h?",
    a: "El plan Oro prioriza tu caso para entregar en < 24h. Muchas recuperaciones se completan en 6–12h según la complejidad."
  },
  {
    q: "¿Necesitan acceso al hosting?",
    a: "Sí, acceso a cPanel/Panel y WordPress. Trabajamos con copias y dejamos bitácora de cambios."
  },
  {
    q: "¿Qué incluye el blindaje?",
    a: "Endurecimiento de login, permisos, firewall, revisión de plugins/temas, y monitoreo si aplica."
  },
  {
    q: "¿Ofrecen garantía?",
    a: "Sí. Si el problema persiste por la misma causa dentro de 7 días, intervenimos sin costo adicional."
  }
];

// Ilustraciones del hero (seleccionadas por el asistente de imágenes)
export const HERO_IMAGES = [
  "https://images.unsplash.com/photo-1654783912259-659d94fff000",
  "https://images.unsplash.com/photo-1623410439361-22ac19216577",
  "https://images.pexels.com/photos/11167645/pexels-photo-11167645.jpeg"
];

// Logos de confianza (texto/placeholder para mock)
export const TRUST_LOGOS = [
  { name: "Wordfence" },
  { name: "MalCare" },
  { name: "Sucuri" },
  { name: "Cloudflare" },
  { name: "UpdraftPlus" }
];

// MANTENIMIENTO PAGE DATA
export const MAINTENANCE_PLANS = [
  {
    id: "vigilancia",
    name: "Vigilancia",
    price: 99,
    period: "mes",
    description: "Protección básica continua",
    highlight: false,
    features: [
      "Actualizaciones mensuales de WP, plugins y temas",
      "Backup semanal automático",
      "Escaneo de seguridad mensual",
      "Monitoreo de uptime 24/7",
      "Reporte mensual de estado",
      "Soporte por email (48h)"
    ]
  },
  {
    id: "crecimiento",
    name: "Crecimiento",
    price: 199,
    period: "mes",
    description: "Blindaje completo + optimización",
    highlight: true,
    features: [
      "Actualizaciones semanales (WP + plugins + temas)",
      "Backup diario automático con retención 30 días",
      "Escaneo de seguridad semanal + WAF activo",
      "Optimización de velocidad mensual",
      "Monitoreo 24/7 con alertas instantáneas",
      "Reporte semanal detallado",
      "Soporte prioritario por WhatsApp/Email (24h)",
      "1 hora de desarrollo mensual incluida"
    ]
  },
  {
    id: "empresarial",
    name: "Empresarial",
    price: 349,
    period: "mes",
    description: "Máxima protección y rendimiento",
    highlight: false,
    features: [
      "Actualizaciones inmediatas (en 24h)",
      "Backup cada 12h con retención 60 días",
      "Escaneo de seguridad diario + hardening avanzado",
      "Optimización continua de velocidad y BD",
      "Monitoreo 24/7 con respuesta proactiva",
      "CDN y caché avanzado configurado",
      "Reportes personalizados semanales",
      "Soporte VIP por teléfono/WhatsApp (4h)",
      "3 horas de desarrollo mensual incluidas",
      "Auditoría de seguridad trimestral"
    ]
  }
];

export const MAINTENANCE_COMPARISON = [
  {
    problem: "Actualizaciones retrasadas o rotas",
    withoutUs: "Riesgo de hackeo, incompatibilidades, sitio roto",
    withUs: "Actualizaciones probadas y aplicadas sin riesgo"
  },
  {
    problem: "Sin backups confiables",
    withoutUs: "Pérdida total de datos en caso de fallo",
    withUs: "Backups automáticos diarios, recuperación garantizada"
  },
  {
    problem: "Vulnerabilidades sin detectar",
    withoutUs: "Ataques exitosos, pérdida de reputación",
    withUs: "Escaneos proactivos y parches inmediatos"
  },
  {
    problem: "Rendimiento degradado",
    withoutUs: "Carga lenta, pérdida de conversiones",
    withUs: "Optimización continua, velocidad máxima"
  },
  {
    problem: "Sin monitoreo",
    withoutUs: "Te enteras cuando los clientes se quejan",
    withUs: "Detectamos y resolvemos antes que te des cuenta"
  }
];

export const MAINTENANCE_BENEFITS = [
  {
    icon: "Shield",
    title: "Seguridad Proactiva",
    desc: "Actualizaciones, parches y monitoreo constante para prevenir ataques antes que sucedan."
  },
  {
    icon: "Zap",
    title: "Velocidad Optimizada",
    desc: "Optimización continua de imágenes, caché, base de datos y código para máximo rendimiento."
  },
  {
    icon: "Clock",
    title: "Ahorra Tiempo",
    desc: "Nosotros nos encargamos de todo el mantenimiento técnico, tú enfocate en tu negocio."
  },
  {
    icon: "FileText",
    title: "Reportes Transparentes",
    desc: "Recibe informes detallados de todas las acciones realizadas y el estado de tu sitio."
  }
];

export const MAINTENANCE_TESTIMONIAL = {
  name: "Roberto Martínez",
  role: "CEO, TechStore México",
  quote: "Después que WPRescate24 recuperó mi tienda online de un ataque, contraté su servicio de mantenimiento. Han pasado 8 meses y duermo tranquilo sabiendo que mi sitio está monitoreado 24/7. Las actualizaciones se hacen sin que yo tenga que preocuparme y el sitio carga más rápido que nunca. Vale cada peso.",
  initials: "RM",
  highlight: "De un rescate de emergencia a 8 meses de total tranquilidad"
};

// HOSTING PAGE DATA
export const HOSTING_PLANS = [
  {
    id: "pro",
    name: "Pro",
    price: 199,
    priceUSD: true,
    period: "mes",
    description: "Servidor dedicado para tu dominio",
    highlight: false,
    specs: {
      performance: "Hasta 50 visitas/segundo",
      visits: "~130,000 visitas/mes optimizadas",
      bandwidth: "Transferencia ilimitada"
    },
    features: [
      "Servidor dedicado exclusivo para tu dominio",
      "Optimización WordPress completa",
      "Certificado SSL Premium",
      "Backups diarios automáticos",
      "Migración gratuita sin downtime",
      "Object Cache optimizado",
      "Soporte técnico WordPress 24/7"
    ]
  },
  {
    id: "business",
    name: "Business",
    price: 349,
    priceUSD: true,
    period: "mes",
    description: "Alto rendimiento y tráfico intensivo",
    highlight: true,
    specs: {
      performance: "Hasta 150 visitas/segundo",
      visits: "~390,000 visitas/mes optimizadas",
      bandwidth: "Transferencia ilimitada"
    },
    features: [
      "Servidor dedicado de alto rendimiento",
      "Optimización avanzada de velocidad",
      "Staging environment incluido",
      "Backups cada 6 horas (retención 30d)",
      "WAF + Protección DDoS avanzada",
      "Object Cache Pro optimizado",
      "Soporte prioritario (respuesta < 2h)",
      "Monitoreo proactivo 24/7",
      "🎁 BONO: Template Premium + 5 licencias Office 365 (contratación anual anticipada)"
    ]
  },
  {
    id: "enterprise",
    name: "Enterprise",
    price: null,
    customQuote: true,
    priceUSD: true,
    period: "mes",
    description: "Servicio personalizado a medida",
    highlight: false,
    specs: {
      performance: "Personalizado según necesidades",
      visits: "Capacidad escalable ilimitada",
      bandwidth: "Transferencia ilimitada"
    },
    features: [
      "Servidor dedicado de máxima potencia",
      "Lazy Server de respaldo automático",
      "Optimización de base de datos MySQL",
      "Backups cada 3 horas (retención 60d)",
      "Image Optimization avanzada",
      "Elasticsearch para búsquedas WooCommerce",
      "Firewall dedicado + IDS/IPS",
      "Object Cache Pro enterprise",
      "Soporte VIP (respuesta < 1h)",
      "Auditoría de rendimiento mensual",
      "Configuración personalizada",
      "🎁 BONO: Template Premium + 5 licencias Office 365 (contratación anual anticipada)"
    ]
  }
];

export const HOSTING_ADVANTAGES = [
  {
    icon: "Zap",
    title: "Optimizado por Expertos",
    desc: "No es hosting genérico. Cada servidor está configurado específicamente para WordPress por nuestros especialistas."
  },
  {
    icon: "Shield",
    title: "Seguridad Gestionada",
    desc: "Más allá de firewalls automáticos: supervisión humana, parches proactivos y respuesta a incidentes."
  },
  {
    icon: "Users",
    title: "Soporte de Técnicos WordPress",
    desc: "No scripts: hablas con expertos que rescatan y optimizan sitios WordPress todos los días."
  },
  {
    icon: "Plane",
    title: "Migración Sin Estrés",
    desc: "Nos encargamos de todo el proceso de migración sin downtime. Tú solo apruebas el resultado."
  },
  {
    icon: "Activity",
    title: "Monitoreo Proactivo",
    desc: "Detectamos y resolvemos problemas antes de que afecten a tus visitantes. Uptime garantizado."
  },
  {
    icon: "Server",
    title: "Infraestructura Premium",
    desc: "Respaldado por servidores.garey.mx: NVMe SSD, transferencias ilimitadas y lazy server de respaldo."
  }
];

export const HOSTING_MIGRATION_PROCESS = [
  {
    step: 1,
    title: "Análisis Inicial",
    desc: "Revisamos tu sitio actual, hosting y necesidades específicas."
  },
  {
    step: 2,
    title: "Preparación del Entorno",
    desc: "Configuramos tu nuevo servidor optimizado para tu caso de uso."
  },
  {
    step: 3,
    title: "Migración y Pruebas",
    desc: "Transferimos tu sitio, lo optimizamos y probamos exhaustivamente."
  },
  {
    step: 4,
    title: "Activación Final",
    desc: "Cambio de DNS coordinado contigo para cero downtime perceptible."
  }
];

export const HOSTING_TESTIMONIAL = {
  name: "Laura Fernández",
  role: "Directora, Agencia Digital MX",
  quote: "Migramos 8 sitios de clientes a su hosting administrado. El cambio fue increíble: velocidades 3x más rápidas, cero problemas técnicos en 6 meses, y cuando necesitamos soporte, hablas con gente que realmente entiende WordPress. No es solo hosting, es tener un equipo técnico extendido.",
  initials: "LF",
  highlight: "8 sitios migrados, velocidad 3x mayor, cero problemas en 6 meses"
};

// OPTIMIZATION PAGE DATA
export const OPTIMIZATION_CORE_WEB_VITALS = [
  {
    metric: "LCP",
    name: "Largest Contentful Paint",
    desc: "Tiempo de carga del elemento principal",
    target: "< 2.5 segundos",
    impact: "Experiencia de carga percibida"
  },
  {
    metric: "FID",
    name: "First Input Delay",
    desc: "Tiempo de respuesta a primera interacción",
    target: "< 100 milisegundos",
    impact: "Interactividad y usabilidad"
  },
  {
    metric: "CLS",
    name: "Cumulative Layout Shift",
    desc: "Estabilidad visual durante la carga",
    target: "< 0.1",
    impact: "Estabilidad y experiencia visual"
  }
];

export const OPTIMIZATION_PROCESS = [
  {
    step: 1,
    title: "Auditoría Técnica Completa",
    desc: "Análisis profundo con herramientas profesionales: GTmetrix, PageSpeed Insights, WebPageTest, y auditoría manual del código."
  },
  {
    step: 2,
    title: "Optimización de Assets",
    desc: "Compresión de imágenes (WebP), minificación CSS/JS, lazy loading, eliminación de recursos bloqueantes."
  },
  {
    step: 3,
    title: "Configuración de Caché y CDN",
    desc: "Implementación de caché avanzado (object cache, page cache, browser cache) y optimización de entrega."
  },
  {
    step: 4,
    title: "Optimización de Base de Datos",
    desc: "Limpieza de tablas, optimización de queries, indexación correcta, eliminación de overhead."
  },
  {
    step: 5,
    title: "Validación y Monitoreo",
    desc: "Pruebas exhaustivas en múltiples dispositivos y configuración de monitoreo continuo de métricas."
  }
];

export const OPTIMIZATION_PLANS = [
  {
    id: "express",
    name: "Optimización Express",
    price: 299,
    priceUSD: true,
    period: "único",
    description: "Optimización técnica completa de una vez",
    highlight: false,
    features: [
      "Auditoría técnica completa",
      "Optimización de imágenes y assets",
      "Configuración de caché avanzado",
      "Minificación CSS/JS",
      "Lazy loading de recursos",
      "Optimización de base de datos",
      "Informe detallado antes/después",
      "Garantía de mejora medible"
    ],
    results: "Mejora promedio: 40-60% en PageSpeed"
  },
  {
    id: "plus-maintenance",
    name: "Optimización + Mantenimiento",
    price: 499,
    priceUSD: true,
    period: "único + 3 meses",
    description: "Optimización profunda + ajustes continuos",
    highlight: true,
    features: [
      "Todo lo de Optimización Express",
      "Implementación de WebP y formatos modernos",
      "Optimización avanzada de Core Web Vitals",
      "Configuración de preload/prefetch estratégico",
      "3 meses de monitoreo activo",
      "Ajustes mensuales proactivos",
      "Re-optimización después de actualizaciones",
      "Soporte prioritario durante 3 meses",
      "Informe mensual de rendimiento"
    ],
    results: "Mejora promedio: 60-80% en PageSpeed + mantenimiento"
  }
];

export const OPTIMIZATION_BENEFITS = [
  {
    icon: "TrendingUp",
    title: "Mejora tu SEO",
    desc: "Google prioriza sitios rápidos. Core Web Vitals son factor de ranking directo desde 2021.",
    stat: "+25% tráfico orgánico promedio"
  },
  {
    icon: "DollarSign",
    title: "Aumenta Conversiones",
    desc: "Cada segundo de demora reduce conversiones 7%. Un sitio rápido vende más.",
    stat: "-32% tasa de rebote típica"
  },
  {
    icon: "Users",
    title: "Mejor Experiencia de Usuario",
    desc: "Usuarios felices regresan. 53% abandona sitios que tardan >3 segundos en cargar.",
    stat: "+40% engagement promedio"
  },
  {
    icon: "Smartphone",
    title: "Optimizado para Móviles",
    desc: "Más del 60% de tráfico es móvil. Optimizamos específicamente para dispositivos móviles.",
    stat: "90+ Mobile PageSpeed típico"
  }
];

export const OPTIMIZATION_TESTIMONIAL = {
  name: "Carlos Mendoza",
  role: "E-commerce Manager, TiendaTech",
  quote: "Nuestro WooCommerce era lento (PageSpeed 35) y las ventas sufrían. Después de la optimización: PageSpeed 92, tiempo de carga de 7s a 1.8s, y lo más importante: conversiones subieron 28% en el primer mes. La inversión se pagó sola en 2 semanas.",
  initials: "CM",
  highlight: "De PageSpeed 35 a 92, conversiones +28% en el primer mes"
};
